<template>
  <form @submit.prevent="handleSubmit(onSubmit)">
    <div class="row">

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-incoTermCode-identifier'" class="col-3 col-form-label">{{ $t('incoterm-code.identifier') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-incoTermCode-identifier'" :value="entity.identifier"/>
          </div>
        </div>

      </div>

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-incoTermCode-name'" class="col-3 col-form-label">{{ $t('incoterm-code.label') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-incoTermCode-name'" :value="entity.name"/>
          </div>
        </div>

      </div>

      <div class="col-4">

        <div class="form-group row">
          <label :for="id + '-incoTermCode-international'" class="col-3 col-form-label">{{ $t('incoterm-code.international') }}</label>
          <div class="col-9">
            <e-form-text :id="id + '-incoTermCode-international'" :value="$t('yes')" v-if="entity.international" />
            <e-form-text :id="id + '-incoTermCode-international'" :value="$t('no')" v-else />
          </div>
        </div>

      </div>

    </div>
  </form>
</template>

<script>

import service from "@/services/incoTermCode.service";
import {log} from "@emons/emons-vue"

export default {
  name: "IncoTermCodeView",
  components: {},
  mounted() {
    log('debug', 'Mounted IncoTermCodeView...')
    this.getEntityDetails()
  },
  props: {
    id: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      entity: {
        abbreviation: null,
        name: null,
        international: null
      }
    }
  },
  methods: {
    getEntityDetails: function () {
      this.$emit('enableSpinner');
      service
          .getEntityDetails(this.link)
          .then(response => {
            this.entity = response.data
            this.$emit('disableSpinner');
          })
    }
  }
}
</script>

<style scoped>

</style>